import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { StorageService, StorageItem } from '../../../services/storageService';

export const useFileStorage = () => {
  const { currentUser } = useAuth();
  const [files, setFiles] = useState<StorageItem[]>([]);
  const [currentPath, setCurrentPath] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const loadFiles = useCallback(async (path: string = '') => {
    if (!currentUser) return;

    setLoading(true);
    setError(null);
    
    try {
      const fileList = await StorageService.listFiles(path);
      setFiles(fileList);
    } catch (err: any) {
      setError('Failed to load files from storage. Please check your permissions.');
    } finally {
      setLoading(false);
    }
  }, [currentUser]);

  const handleNavigateUp = () => {
    if (currentPath) {
      const parentPath = currentPath.split('/').slice(0, -1).join('/');
      setCurrentPath(parentPath);
      loadFiles(parentPath);
    }
  };

  const clearError = () => {
    setError(null);
  };

  useEffect(() => {
    if (currentUser) {
      loadFiles();
    }
  }, [currentUser, loadFiles]);

  return {
    files,
    currentPath,
    loading,
    error,
    loadFiles,
    handleNavigateUp,
    clearError,
    setFiles,
    setCurrentPath,
    setLoading,
    setError
  };
};
